import type { FC } from 'react'
import React, { memo } from 'react'
import classNames from 'classnames'
import NavSuccessNew from '../NavSuccessNew/NavSuccessNew'
import { messages } from './messages'
import type { TSuccessMoreComponentProps } from './types'
import './styles.scss'

const SuccessMoreComponent: FC<TSuccessMoreComponentProps> = ({ navItems, buttonClassName, descriptionClassName }) => {
  return (
    <div className="applyingFinancingOfferSuccessModalMore">
      <h3 className="applyingFinancingOfferSuccessModalMore__title with-custom-offsets">{messages.title}</h3>
      <span className={classNames(descriptionClassName, 'applyingFinancingOfferSuccessModalMore__description with-custom-offsets')}>
        {messages.description}
      </span>
      <div className="applyingFinancingOfferSuccessModalMore__navSuccess">
        <NavSuccessNew itemClassName={buttonClassName} navItems={navItems} />
      </div>
    </div>
  )
}

export const SuccessMore = memo(SuccessMoreComponent)
